<template>
    <!--弹窗-->
    <el-dialog
        width="650px"
        :title="title"
        :visible.sync="visible"
        :before-close="handleClose"
        top="5vh"
        append-to-body
    >
        <el-form ref="formData" :model="formData" label-width="230px" :rules="rules" :inline="true">
            <el-form-item label="商品图片：">
                <el-input clearable v-model="formData.img_url"
                          placeholder="请输入商品图片链接" size="mini" disabled></el-input>
            </el-form-item>
            <el-form-item label="国家: " class="query-form-item" prop="state">
                <el-select
                    v-model="formData.state"
                    ref="carrerSelect"
                    style="width: 150px;"
                    size="mini"
                    filterable
                    disabled
                >
                    <el-option
                        v-for="item in $common.us_arr_normal"
                        :key="item.us"
                        :label="item.title"
                        :value="item.us"
                        :disabled="item.disabled">
                        <div class="keywords_arr_div">
                            <icon-svg :icon-class="item.us.toUpperCase()"
                                      style="font-size: 24px;margin-right:5px;"></icon-svg>
                            <span style="font-weight: 700; font-size: 14px;margin-left: 10px;">{{ item.title }}</span>
                        </div>
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="ASIN: " class="query-form-item" prop="asin">
                <el-input v-model="formData.asin" placeholder="请输入ASIN" clearable style="width: 150px;" size="mini"
                          disabled></el-input>
            </el-form-item>
            <el-form-item label="销售价格：">
                <el-input-number
                    v-model="formData.selling_price"
                    style="width: 300px;"
                    :min="0.00"
                    :step="0.01"
                    size="mini"
                    placeholder="请输入销售价格"
                >
                </el-input-number>
            </el-form-item>
            <el-form-item label="父ASIN: " class="query-form-item" prop="asin">
                <el-input v-model="formData.parent_asin" placeholder="请输入父ASIN" clearable
                          size="mini" disabled></el-input>
            </el-form-item>
            <el-form-item label="上架时间：">
                <el-date-picker
                    v-model="formData.listed_since"
                    type="date"
                    size="mini"
                    placeholder="选择上架时间"
                    disabled
                >
                </el-date-picker>
            </el-form-item>
            <el-form-item label="品牌：">
                <el-input style="width: 150px;" clearable v-model="formData.brand" placeholder="请输入品牌" size="mini"
                          disabled></el-input>
            </el-form-item>
            <el-form-item label="评分：">
                <el-input-number v-model="formData.rating" style="width: 300px;" :min="0" :step="0.1" :max="5"
                                 size="mini" placeholder="请输入评分" disabled></el-input-number>
            </el-form-item>
            <el-form-item label="评论数：">
                <el-input-number v-model="formData.rating_count" style="width: 300px;" :min="0" :step="1" size="mini"
                                 placeholder="请输入评论数" disabled></el-input-number>
            </el-form-item>
            <el-form-item label="标题：">
                <el-input style="width: 150px;" clearable v-model="formData.title" placeholder="请输入标题"
                          size="mini"></el-input>
            </el-form-item>
            <el-form-item label="类目:">
                <el-input style="width: 150px;" clearable v-model="formData.category" placeholder="请输入类目"
                          size="mini" disabled></el-input>
            </el-form-item>
            <el-form-item label="类目树:">
                <el-input style="width: 150px;" clearable v-model="formData.category_tree" placeholder="请输入类目树"
                          size="mini" disabled></el-input>
            </el-form-item>
            <el-form-item label="子类目:">
                <el-input style="width: 150px;" clearable v-model="formData.categories_str" placeholder="请输入子类目"
                          size="mini" disabled></el-input>
            </el-form-item>
            <el-form-item label=" ">
                <el-button @click="choose1688" size="mini">选择1688产品</el-button>
            </el-form-item>
            <el-form-item label="1688产品链接：">
                <el-input style="width: 150px;" clearable v-model="formData.ali_href_link"
                          placeholder="请输入1688产品链接" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="1688产品价格：">
                <el-input-number
                    v-model="formData.ali_factory_price"
                    style="width: 300px;"
                    :min="0.00"
                    :step="0.01"
                    size="mini"
                    placeholder="请输入1688产品价格"
                >
                </el-input-number>
            </el-form-item>
            <el-form-item label="1688产品图片Url：">
                <el-input style="width: 150px;" clearable v-model="formData.ali_pic_url"
                          placeholder="请输入1688产品图片Url" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="1688产品标题：">
                <el-input style="width: 150px;" clearable v-model="formData.ali_title"
                          placeholder="请输入1688产品标题" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="退货率：">
                <el-input v-model="formData.refund_rate" style="width: 150px;margin-right:20px;" size="mini"
                          placeholder="请输入退货率">
                    <template slot="append">%</template>
                </el-input>
            </el-form-item>
            <el-form-item label="是否季节性：">
                <el-checkbox v-model="formData.is_seasonality">是否季节性</el-checkbox>
            </el-form-item>
            <el-form-item label="规格-长(cm)：">
                <el-input style="width: 150px;" clearable v-model="formData.long"
                          placeholder="请输入规格-长(cm)" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="规格-宽(cm)：">
                <el-input style="width: 150px;" clearable v-model="formData.wide"
                          placeholder="请输入规格-宽(cm)" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="规格-高(cm)：">
                <el-input style="width: 150px;" clearable v-model="formData.height"
                          placeholder="请输入规格-高(cm)" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="规格-重(g)：">
                <el-input style="width: 150px;" clearable v-model="formData.weight"
                          placeholder="请输入规格-重(g)" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="fba费用：">
                <el-input style="width: 150px;" clearable v-model="formData.fba_fees"
                          placeholder="请输入fba费用" size="mini" disabled></el-input>
            </el-form-item>
            <el-form-item label="运费：">
                <el-input-number
                    v-model="formData.freight"
                    style="width: 300px;"
                    :min="0.00"
                    :step="0.01"
                    size="mini"
                    placeholder="请输入运费"
                    disabled
                >
                </el-input-number>
            </el-form-item>
            <el-form-item label="运费单价/kg：">
                <el-input-number
                    v-model="formData.freight_unit_price"
                    style="width: 300px;"
                    :min="0.00"
                    :step="0.01"
                    size="mini"
                    placeholder="请输入运费单价/kg"
                    disabled
                >
                </el-input-number>
            </el-form-item>
<!--            <el-form-item label="运输模式：">-->
<!--                <el-input style="width: 150px;" clearable v-model="formData.deliver_mode"-->
<!--                          placeholder="请输入运输模式" size="mini" disabled></el-input>-->
<!--            </el-form-item>-->
            <el-form-item label="运输模式：" class="query-form-item">
                <el-select v-model="formData.deliver_mode" placeholder="请选择" size="mini" filterable>
                    <el-option :label="item.label" :value="item.value" v-for="item in $common.deliverModeArr"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="平台佣金：">
                <el-input-number
                    v-model="formData.platform_commission"
                    style="width: 300px;"
                    :min="0.00"
                    :step="0.01"
                    size="mini"
                    placeholder="请输入平台佣金"
                    disabled
                >
                </el-input-number>
            </el-form-item>
            <el-form-item label="亚马逊物流配送费：">
                <el-input-number
                    v-model="formData.delivery_charge"
                    style="width: 300px;"
                    :min="0.00"
                    :step="0.01"
                    size="mini"
                    placeholder="请输入亚马逊物流配送费"
                    disabled
                >
                </el-input-number>
            </el-form-item>
            <el-form-item label="退货费用：">
                <el-input-number
                    v-model="formData.refund_charge"
                    style="width: 300px;"
                    :min="0.00"
                    :step="0.01"
                    size="mini"
                    placeholder="请输入退货费用"
                    disabled
                >
                </el-input-number>
            </el-form-item>
            <el-form-item label="Vat税费：">
                <el-input-number
                    v-model="formData.vat_charge"
                    style="width: 300px;"
                    :min="0.00"
                    :step="0.01"
                    size="mini"
                    placeholder="请输入Vat税费"
                    disabled
                >
                </el-input-number>
            </el-form-item>
            <el-form-item label="1-9月仓储费：">
                <el-input-number
                    v-model="formData.early_storage_charge"
                    style="width: 300px;"
                    :min="0.00"
                    :step="0.01"
                    size="mini"
                    placeholder="请输入1-9月仓储费"
                    disabled
                >
                </el-input-number>
            </el-form-item>
            <el-form-item label="10-12月仓储费：">
                <el-input-number
                    v-model="formData.late_storage_charge"
                    style="width: 300px;"
                    :min="0.00"
                    :step="0.01"
                    size="mini"
                    placeholder="请输入10-12月仓储费"
                    disabled
                >
                </el-input-number>
            </el-form-item>
            <el-form-item label="美国旺季差额：">
                <el-input-number
                    v-model="formData.us_peak_season_balance"
                    style="width: 300px;"
                    :min="0.00"
                    :step="0.01"
                    size="mini"
                    placeholder="请输入美国旺季差额"
                    disabled
                >
                </el-input-number>
            </el-form-item>
            <el-form-item label="0利润销售价格：">
                <el-input-number
                    v-model="formData.seller_price_no_profit"
                    style="width: 300px;"
                    :min="0.00"
                    :step="0.01"
                    size="mini"
                    placeholder="请输入0利润销售价格"
                    disabled
                >
                </el-input-number>
            </el-form-item>
            <el-form-item label="0利润销售价格(免税)：">
                <el-input-number
                    v-model="formData.seller_price_no_profit_no_tax"
                    style="width: 300px;"
                    :min="0.00"
                    :step="0.01"
                    size="mini"
                    placeholder="请输入0利润销售价格(免税)"
                    disabled
                >
                </el-input-number>
            </el-form-item>
            <el-form-item label="1-9月利润：">
                <el-input-number
                    v-model="formData.early_profit"
                    style="width: 300px;"
                    :min="0.00"
                    :step="0.01"
                    size="mini"
                    placeholder="请输入1-9月利润"
                    disabled
                >
                </el-input-number>
            </el-form-item>
            <el-form-item label="1-9月利润(免税)：">
                <el-input-number
                    v-model="formData.early_profit_no_tax"
                    style="width: 300px;"
                    :min="0.00"
                    :step="0.01"
                    size="mini"
                    placeholder="请输入1-9月利润(免税)"
                    disabled
                >
                </el-input-number>
            </el-form-item>
            <el-form-item label="1-9月投资回报率：">
                <el-input-number
                    v-model="formData.early_investment_return_rate"
                    style="width: 300px;"
                    :min="0.00"
                    :step="0.01"
                    size="mini"
                    placeholder="请输入1-9月投资回报率"
                    disabled
                >
                </el-input-number>
            </el-form-item>
            <el-form-item label="10-12月利润：">
                <el-input-number
                    v-model="formData.late_profit"
                    style="width: 300px;"
                    :min="0.00"
                    :step="0.01"
                    size="mini"
                    placeholder="请输入10-12月利润"
                    disabled
                >
                </el-input-number>
            </el-form-item>
            <el-form-item label="10-12月利润(免税)：">
                <el-input-number
                    v-model="formData.late_profit_no_tax"
                    style="width: 300px;"
                    :min="0.00"
                    :step="0.01"
                    size="mini"
                    placeholder="请输入10-12月利润(免税)"
                    disabled
                >
                </el-input-number>
            </el-form-item>
            <el-form-item label="10-12月投资回报率：">
                <el-input-number
                    v-model="formData.late_investment_return_rate"
                    style="width: 300px;"
                    :min="0.00"
                    :step="0.01"
                    size="mini"
                    placeholder="请输入10-12月投资回报率"
                    disabled
                >
                </el-input-number>
            </el-form-item>
        </el-form>
        <categoryList :visible="showCategoryList" @choose1688Info="choose1688Info" :copyData="copyData"
                      @close-callback="showCategoryList=false"></categoryList>
        <el-row style="margin-top:17px; ">
            <el-button
                style="float:right;margin-left:6px;"
                size="mini"
                type="danger"
                plain
                @click="handleClose()"
            >关 闭
            </el-button
            >
            <el-button
                style="float:right"
                size="mini"
                type="primary"
                @click="submitForm()"
                :loading="loading"
            >修 改
            </el-button
            >
        </el-row>
    </el-dialog>
</template>
<script>
import * as api from '@/api/advAnalys/advAnalys.js'
import categoryList from './categoryList'

export default {
    components: {categoryList},
    data() {
        return {
            loading: false,
            showCategoryList: false,
            options: [],
            rules: {
                keepa_category_id: [
                    {
                        required: true,
                        message: '请选择根类目',
                        trigger: 'blur'
                    },
                ],
            },
            formData: {}
        }
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ''
        },
        copyData: {
            type: Object,
            default: {}
        },
    },
    watch: {
        copyData: {
            handler(val) {
                if (this.visible) {
                    this.formData = val
                }
            },
            immediate: true,
            deep: true
        },
    },

    methods: {
        choose1688Info(data) {
            this.formData.ali_href_link = data.detail_url
            this.formData.ali_factory_price = data.price
            this.formData.ali_title = data.title
            this.formData.ali_pic_url = data.pic_url
            this.showCategoryList = false
        },
        choose1688() {
            this.showCategoryList = true
        },
        // 保存信息
        submitForm() {
            this.$refs['formData'].validate(valid => {
                if (valid) {
                    api.cost_analysis_personal_personal_operation({
                        id: this.formData.id,
                        title: this.formData.title,
                        ali_href_link: this.formData.ali_href_link,
                        ali_factory_price: this.formData.ali_factory_price,
                        ali_pic_url: this.formData.ali_pic_url,
                        ali_title: this.formData.ali_title,
                        refund_rate: this.formData.refund_rate,
                        is_seasonality: this.formData.is_seasonality ? 1 : 0,
                        long: this.formData.long,
                        wide: this.formData.wide,
                        height: this.formData.height,
                        weight: this.formData.weight,
                        selling_price: this.formData.selling_price,
                    }).then(res => {
                        this.loading = false
                        if (res.code === 0) {
                            this.$message({message: '修改成功', type: 'success'})
                            this.$set(this, 'formData', res.data)
                            this.$emit('refreshList')
                        } else {
                            this.$message({type: 'error', message: res.message})
                        }
                    }).catch(() => {
                        this.loading = false
                        this.$message({
                            type: 'error',
                            message: '网络出现问题，请刷新页面！'
                        })
                    })
                } else {
                    this.loading = false
                    this.$message({
                        type: 'error',
                        message: '请填写相应内容！'
                    })
                }
            })
        },
        // 关闭弹窗
        handleClose(isshow = false) {
            this.formData = {
                keepa_category_id: [],
            }
            this.$refs['formData'].resetFields()
            this.loading = false
            this.$emit('close-callback', isshow)
        },
    }
}
</script>
<style type="text/scss" lang="scss" scoped>
.content {
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #cecfd1;
    font-size: 12px;
    color: #000;

    .shu {
        border-right: 1px solid #cecfd1;
    }

    .content-div {
        width: 50%;
        padding: 25px 20px;
    }

    .content-buttom {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #cecfd1;
        padding-bottom: 8px;
        margin-bottom: 10px;
    }

    .content-buttom-txet {
        color: rgb(57, 187, 252);
        cursor: pointer;
    }

    .content-data {
        width: 100%;
        height: 230px;
        overflow: auto;

        .content-list {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 10px 0;

            .cha {
                cursor: pointer;
                font-size: 15px;
                color: rgb(158, 192, 209);
                margin: 0 10px 0 12px;
            }
        }
    }

    /deep/ .content-data::-webkit-scrollbar {
        width: 3px;
        height: 5px;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ .content-data::-webkit-scrollbar-track-piece {
        background-color: #ffff;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ .content-data::-webkit-scrollbar-thumb:vertical {
        height: 5px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ .content-data::-webkit-scrollbar-thumb:horizontal {
        width: 3px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
}

.media-txt {
    font-size: 15px;
    color: #6a6c6f;
    font-weight: 600;
    margin-bottom: 8px;
}

/deep/ .el-dialog__body {
    padding: 0px 20px 20px 20px !important;
}

/deep/ .el-form-item {
    margin-bottom: 12px !important;
}
</style>
